<template>
	<div class="home-live">
		<div class="home-live1">
			<template v-if="isPc">
				<img class="title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-live-en.png" alt="">
				<img class="title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-live.png" alt="">
			</template>
			<template v-else>
				<img class="title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-live-en.png" alt="">
				<img class="title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-live.png" alt="">
			</template>
		</div>
		<div class="home-live2">
			<div class="btns">
				<div class="btn" @click="toLive">
					{{ $t('newbanner6') }}
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</div>
			</div>
		</div>
		<div class="home-live3-wrapper">
			<div class="home-live3">
				<div class="item" v-for="(item, index) in list" :key="index">
					<div class="inner-item" @click="videoFn(item)">
						<div class="img">
							<img class="img" v-if="item.coverUrl" :src="item.coverUrl + '?x-image-process=image/resize,w_1200,limit_0'" alt="">
							<video class="img" v-else ref="video" :src="item.resourceUrl"></video>
							<img class="icon" v-if="activeIndex != index" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/video.png" alt="">
						</div>
						<div class="text">{{ item['name' + En] }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
export default {
	name: 'news_events',
	data() {
		return {
			list: [],
			activeIndex: -1
		}
	},
	created() {
		this.getData()
	},
	methods: {
		getData() {
			protal.webLivelist(4).then(res => {
				this.list = res.data
			})
		},
		videoFn(item, index) {
			// this.activeIndex = -1
			// if (this.$refs.video[index].paused) {
			// 	this.$refs.video[index].play()
			// 	this.activeIndex = index
			// } else {
			// 	this.$refs.video[index].pause()
			// }
			if (item.dataType == 1) {
				location.href = item.resourceUrl
			} else {
				this.$router.push({ name: 'live', query: { uuid: item.uuid } })
			}
		},
		toLive() {
			location.href = 'https://gociif.ciif-expo.com/pages/activity/index'
		}
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.home-live {
		padding-top: 138px;
		padding-bottom: 140px;
		position: relative;
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun2.png);
		background-size: 232px auto;
		background-repeat: no-repeat;
		background-position: right top;
		
		.home-live1 {
			
			.title {
				width: auto;
				height: 144px;
			}
		}

		.home-live2 {
			position: absolute;
			right: 130px;
			top: 184px;

			.btns {
				display: flex;
				padding-left: 140px;

				.btn {
					height: 56px;
					border: 1px solid #fff;
					border-radius: 12px;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 16px;
					color: #fff;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
						pointer-events: none;
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
					}
				}
			}
		}

		.home-live3 {
			width: 1640px;
			margin: 0 auto;
			border-top: 1px solid rgba(255, 255, 255, 0.2);
			padding-top: 57px;
			display: flex;

			.item {
				width: 392px;
				margin-right: 24px;
				cursor: pointer;

				.inner-item {
					width: 100%;
					border-radius: 24px;
					border: 1px solid rgba(255,255,255,0.2);
					padding-top: 16px;
					padding-bottom: 24px;

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
					}
				}

				&:last-child {
					margin-right: 0;
				}

				.img {
					width: 360px;
					margin: 0 auto;
					position: relative;
					border-radius: 12px;

					.img {
						width: 100%;
						height: auto;
					}

					.icon {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: 80px;
						height: auto;
						pointer-events: none;
					}
				}

				.text {
					font-family: Inter, syn;
					font-weight: 500;
					font-size: 24px;
					color: #FFFFFF;
					line-height: 36px;
					text-align: left;
					font-style: normal;
					width: 360px;
					margin: 16px auto 0;
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.home-live {
		padding-top: 1.39rem;
		padding-bottom: .8rem;
		background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun2.png);
		background-repeat: no-repeat;
		background-size: 2.3rem auto;
		background-position: right top;
		position: relative;
		
		.home-live1 {
			
			.title {
				width: auto;
				height: 1.44rem;
			}
		}

		.home-live2 {
			margin-top: .12rem;
			width: 6.78rem;
			padding-bottom: .36rem;
			margin: .12rem auto 0.6rem;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);

			.btns {
				display: flex;

				.btn {
					height: .88rem;
					border: 1px solid #fff;
					border-radius: .2rem;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .24rem;
					color: #fff;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
						pointer-events: none;
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
					}
				}
			}
		}

		.home-live3-wrapper {
			width: 7.14rem;
			margin-left: .36rem;
			padding-bottom: 0.4rem;
			overflow: auto;

			&::-webkit-scrollbar {
				width: 0;
			}
		}

		.home-live3 {
			display: inline-flex;
			padding-right: .16rem;

			.item {
				width: 3.32rem;
				margin-right: .16rem;
				cursor: pointer;

				.inner-item {
					width: 100%;
					border-radius: .28rem;
					border: 1px solid rgba(255,255,255,0.2);
					padding-top: .16rem;
					padding-bottom: .32rem;

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
					}
				}

				&:last-child {
					margin-right: 0;
				}

				.img {
					width: 3rem;
					margin: 0 auto;
					position: relative;
					border-radius: .16rem;

					.img {
						width: 100%;
						height: auto;
					}

					.icon {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
						width: .8rem;
						height: auto;
						pointer-events: none;
					}
				}

				.text {
					font-family: Inter, syn;
					font-weight: 500;
					font-size: .26rem;
					color: #FFFFFF;
					line-height: .36rem;
					text-align: left;
					font-style: normal;
					width: 3rem;
					margin: .2rem auto 0;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/live.vue